import { Button } from '@/components/ui/button'
import { tokenFetcher, useAuthStore } from '@/hooks'
import { useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import useSWRMutation from 'swr/mutation'

// CLI login: the monday skill's login.js opens /login?cli=<id>. The id rides
// through the Feishu `state` param, the server stashes the session under it
// for 10 minutes, and the CLI claims it via POST /cli-login/claim.
const CLI_STATE_PREFIX = 'cli_'
const CLI_ID_PATTERN = /^[A-Za-z0-9_-]{32,128}$/
const cliIdFromState = (state) =>
  typeof state === 'string' &&
  state.startsWith(CLI_STATE_PREFIX) &&
  CLI_ID_PATTERN.test(state.slice(CLI_STATE_PREFIX.length))
    ? state.slice(CLI_STATE_PREFIX.length)
    : null

const WithCode = ({ code, cli }) => {
  const { setToken } = useAuthStore()
  const navigate = useNavigate()
  const { trigger, isMutating, isError, data } = useSWRMutation(
    '/login',
    tokenFetcher,
    {
      onSuccess: (data) => {
        if (data) {
          setToken(data)
          if (!cli) navigate('/roi')
        }
      },
      onError: () => {
        navigate('/login')
      },
    },
  )

  useEffect(() => {
    if (code) {
      trigger(cli ? { code, cli } : { code })
    }
  }, [code, cli, trigger])

  return (
    <div>
      {isMutating && <p>Logging in...</p>}
      {isError && <p>Login failed.</p>}
      {cli && data && (
        <p>
          CLI login succeeded ({data.user?.name}). Return to the terminal; you
          can close this page.
        </p>
      )}
    </div>
  )
}

const LoginPage = () => {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const queryParams = Object.fromEntries(searchParams.entries())
  if (queryParams.code) {
    return (
      <div className="flex flex-col max-auto items-center">
        <WithCode
          code={queryParams.code}
          cli={cliIdFromState(queryParams.state)}
        />
      </div>
    )
  }

  const cli = CLI_ID_PATTERN.test(queryParams.cli || '')
    ? queryParams.cli
    : null
  const from = location.state?.from?.pathname || '/'
  const state = cli ? `${CLI_STATE_PREFIX}${cli}` : from
  const appId = `cli_a42177b6ad4e500d`
  const redirect_uri = `${window.location.origin}/login`
  const href = `https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${encodeURI(
    redirect_uri,
  )}&app_id=${appId}&state=${state}`

  return (
    <div className="flex items-center justify-center min-h-screen">
      <h1 className="my-5">Welcome to Monday.</h1>
      <a href={href}>
        <Button variant="outline">
          {cli ? 'Login use feishu (for CLI)' : 'Login use feishu'}
        </Button>
      </a>
    </div>
  )
}

export default LoginPage
